import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@mui/material/styles";
import { createAppTheme } from "./mui";
import { LoadingKeyframes } from "../components/loading";

/**
 * 讓 MUI 主題跟著 <html data-theme> 切深淺色。
 *
 * 深淺色的真正來源是 utils/theme.js（頁首與「設定 → 偏好設定」都會改 <html data-theme>），
 * 這裡只是旁觀者：用 MutationObserver 盯著屬性，變了就換一份 MUI 主題，
 * 不另外存一份狀態，兩邊才不會各說各話。
 */
const modeOf = () => (document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light");

export default function MuiThemeBridge({ children }) {
  const [mode, setMode] = useState(modeOf);

  useEffect(() => {
    const mo = new MutationObserver(() => setMode(modeOf()));
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => mo.disconnect();
  }, []);

  const theme = useMemo(() => createAppTheme(mode), [mode]);
  return (
    <ThemeProvider theme={theme}>
      {/* 載入動畫的 keyframes 全站只掛一份（components/loading） */}
      <LoadingKeyframes />
      {children}
    </ThemeProvider>
  );
}

MuiThemeBridge.propTypes = { children: PropTypes.node };
MuiThemeBridge.defaultProps = { children: null };
